module.exports = __webpack_public_path__ + "static/media/109.87ca191e.png";